export class EmployeeIdariRequest {
    effectiveStartDate: String;
    effectiveEndDate: String;
    explanation: String;
    employeeId: number;
    id: number;
}
